import { useState } from "react";
import { XtreamAdapter, type XtreamLiveChannel } from "../../adapters/relayed/xtream";

export interface XtreamConnectStepProps {
  onConnected: (channels: XtreamLiveChannel[], base: string, user: string, pass: string) => void;
}

export function XtreamConnectStep({ onConnected }: XtreamConnectStepProps) {
  const [base, setBase] = useState("");
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleConnect = async () => {
    setError(null);
    setLoading(true);
    try {
      const channels = await XtreamAdapter.listLiveChannels(base, user, pass);
      onConnected(channels, base, user, pass);
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : "Failed to connect";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h3>Connect Xtream Codes</h3>
      <input value={base} onChange={(e) => setBase(e.target.value)} placeholder="http://panel.example.com:8080" style={{ width: "100%", padding: 8, marginBottom: 8 }} />
      <input value={user} onChange={(e) => setUser(e.target.value)} placeholder="Username" style={{ width: "100%", padding: 8, marginBottom: 8 }} />
      <input type="password" value={pass} onChange={(e) => setPass(e.target.value)} placeholder="Password" style={{ width: "100%", padding: 8, marginBottom: 8 }} />
      <button onClick={handleConnect} disabled={loading || !base || !user || !pass}>
        {loading ? "Connecting..." : "Connect"}
      </button>
      {error && <div style={{ color: "#c00", marginTop: 12 }}>{error}</div>}
    </div>
  );
}
